import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CampaignInterface } from 'app/models/campaign.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { CampaignDataTransformPost } from './data-transforms/campaign.data.transform.post';
import { CampaignDataTransformGet } from './data-transforms/campaign.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class CampaignHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/campaigns(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformUp: CampaignDataTransformGet,
    private readonly _transformDown: CampaignDataTransformPost,
  ) {}

  intercept(req: HttpRequest<CampaignInterface>, next: HttpHandler): Observable<HttpEvent<CampaignInterface>> {
    return RequestService.getTransformedHttpEvent<CampaignInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
